export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path)
}
// 验证手机号
export function isPhone(value) {
  return /^[1]\d{10}$/.test(value)
}
// 密码 8~20位数字及字母符号结合
export function isPassword(value) {
  // return /^.*(?=.{8,20})^(?:(?=.*[a-zA-Z])(?=.*[\d])|(?=.*[!#+,.\\=:=@-])(?=.*[\d])|(?=.*[!#+,.\\=:=@-])(?=.*[a-zA-Z])).+$/.test(value)
  return /^(?![\d]+$)(?![a-zA-Z]+$)(?![!#.$%^&*]+$)[\da-zA-Z!#.$%^&*]{8,20}$/.test(value)
}
// 中英文及数字
export function isName(value, num = 16) {
  return new RegExp(`^([\u4E00-\uFA29]|[\uE7C7-\uE7F3]|[a-zA-Z0-9]){1,${num}}$`).test(value)
}
// 6位邮政编码
export function isPostalCode(value) {
  return /^[0-9]\d{5}(?!\d)$/.test(value)
}
// 邮箱
export function isEmail(value) {
  return /^([a-zA-Z]|[0-9])(\w|-|\.)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/.test(value)
}
